export const PdfOrientationTypeEnumValues = ['LANDSCAPE', 'PORTRAIT'];
export const ExternalFileStatusEnumValues = ['UPLOADING', 'COMPLETED'];
export const UserSourceEnumValues = ['ADCONSOLE', 'SSO'];
export const IdentityProviderTypeEnumValues = ['GOOGLE'];
export const DiscountValueTypeEnumValues = ['PERCENTAGE', 'AMOUNT'];
export const DiscountApplyToEnumValues = ['GROSS1', 'GROSS2', 'GROSS3', 'NET1', 'NET2', 'NET3'];
export const DiscountOperationTypeEnumValues = ['DISCOUNT', 'SURCHARGE'];
export const UserRoleEnumValues = ['COMPANY_ADMIN', 'USER'];
export const CompanyRoleEnumValues = ['ADMIN', 'CUSTOMER'];
export const CompanyPositionEnumValues = ['SALES', 'SALES_SUPPORT', 'ADOPS', 'ADOPS_SALES', 'ADOPS_SALES_SUPPORT'];
export const RoleEnumValues = ['ADVERTISER', 'AGENCY', 'BROKER', 'OTHER', 'PUBLISHER'];
export const EmailPlaceholderEnumValues = [
    'USER_EMAIL',
    'SALES_CONTACT_EMAIL',
    'CREATOR_EMAIL',
    'ASSIGNEE_EMAIL',
    'CONTACT_EMAIL',
    'RECEIVERS',
    'COMPANY_GENERAL_EMAIL',
    'ADMANAGEMENT_IF_BOOKED_OR_SELFBOOKED',
    'PUBLIC_COMMENT_RECEIVER',
    'CAMPAIGN_INVOICE_EMAILS',
    'CAMPAIGN_COMMUNICATION_EMAIL',
    'CAMPAIGN_SCREENSHOT_EMAILS',
    'CAMPAIGN_CREATIVE_EMAILS',
    'CAMPAIGN_REPORT_EMAILS',
    'CAMPAIGN_SALES',
    'CAMPAIGN_CREATOR',
    'INVOICE_EMAILS',
];
export const PlaceholderEnumValues = [
    'COMPANY_NAME',
    'CAMPAIGN_LINK',
    'CAMPAIGN_NAME',
    'INTERNAL_ORDER_NUMBER',
    'SALES_UNIT_NAME',
    'CAMPAIGN_POSITIONS',
    'ATTACHMENT_LINKS',
    'MESSAGE',
    'ATTACHMENT_LIST',
    'CREATOR_NAME',
    'INVOICE_NUMBER',
    'SCREENSHOTS_ARCHIVE_LINK',
    'ACCOUNT',
    'CREATIVE_PREVIEW_LINKS',
    'REFERENCE_NUMBER',
    'CUSTOMER_NAME',
    'CAMPAIGN_SALES_NAME',
];
export const MailTemplateTypeEnumValues = [
    'SEND_INVOICE',
    'PAYMENT_REMINDER_1',
    'PARTIALLY_PAID_PAYMENT_REMINDER_1',
    'PAYMENT_REMINDER_2',
    'PARTIALLY_PAID_PAYMENT_REMINDER_2',
    'PAYMENT_REMINDER_3',
    'PARTIALLY_PAID_PAYMENT_REMINDER_3',
    'PAYMENT_PERSONAL_CALL_REMINDER',
    'PARTIALLY_PAID_PAYMENT_PERSONAL_CALL_REMINDER',
    'SEND_SCREENSHOTS',
    'SEND_POSITIONS_SCREENSHOTS',
    'REQUEST_CREATIVES',
    'SEND_REPORT',
    'SEND_END_CAMPAIGN_REPORT',
    'SEND_STATE_READY',
    'SEND_UNDERDELIVERED_REPORT',
    'COMMENT',
    'REPORTING_TOOL_MAIL',
    'OPS_CAMPAIGN_DECLINED',
    'POSITION_EXCLUDED',
    'PAYOUT_REPORT',
    'ACCOUNT_EXCLUDED',
    'OFFER_NOTIFICATION',
    'SELF_BOOKING_CAMPAIGN_ACTIVATED',
    'CREDIT_CARD_PAYMENT_SUCCESSFUL',
    'CREDIT_CARD_PAYMENT_FAILED',
    'SELFBOOKING_GREETING',
    'SELFBOOKING_SEND_REMINDER',
    'SELFBOOKING_SEND_OVERDUE',
    'SELFBOOKING_ORDER_CONFIRMATION',
    'SELFBOOKING_CAMPAIGN_RESUMED',
    'SELFBOOKING_CAMPAIGN_UNDERDELIVERY',
    'SELFBOOKING_CAMPAIGN_FINISHED',
    'INVITATION',
    'RESTORE_PASSWORD',
    'SEND_ORDER',
    'SEND_OFFER',
    'SEND_PRINT_PROOFS',
    'OFFER_REJECTED',
    'OFFER_EXPIRED',
    'FUNNEL_TASK_ASSIGNED_NOTIFICATION',
    'FUNNEL_DECLINED_TASK_SNOOZING_NOTIFICATION',
    'FUNNEL_TASK_UNSNOOZED_NOTIFICATION',
    'SECOND_FACTOR_CONFIRMATION',
    'REQUEST_ANALOG_CREATIVES',
    'POST_DIGITAL_CONFIRMATION_NOTIFICATION',
    'POST_DIGITAL_CANCELLATION_NOTIFICATION',
    'DRAFT_CREATIVE_NOTIFICATION',
    'CREATIVE_DEACTIVATED_NOTIFICATION',
    'NO_GENERATIONS_DETECTED_ALERT',
    'BOUNCE',
    'TICKET_STATUS_CHANGE_NOTIFICATION',
    'TICKET_ASSIGNEE_CHANGE_NOTIFICATION',
    'TICKET_COMMENT_NOTIFICATION',
];
export const ClientMailTemplateTypeEnumValues = [
    'SEND_INVOICE',
    'PAYMENT_REMINDER_1',
    'PARTIALLY_PAID_PAYMENT_REMINDER_1',
    'PAYMENT_REMINDER_2',
    'PARTIALLY_PAYMENT_REMINDER_2',
    'PAYMENT_REMINDER_3',
    'PARTIALLY_PAYMENT_REMINDER_3',
    'PAYMENT_PERSONAL_CALL_REMINDER',
    'PARTIALLY_PAYMENT_PERSONAL_CALL_REMINDER',
    'SEND_SCREENSHOTS',
    'REQUEST_CREATIVES',
    'SEND_REPORT',
    'SEND_END_CAMPAIGN_REPORT',
    'SEND_STATE_READY',
    'SEND_UNDERDELIVERED_REPORT',
    'COMMENT',
    'REPORTING_TOOL_MAIL',
    'FUNNEL_TASK_ASSIGNED_NOTIFICATION',
    'FUNNEL_DECLINED_TASK_SNOOZING_NOTIFICATION',
];
export const PdfTypeEnumValues = [
    'ORDER',
    'OFFER',
    'REPORT',
    'PAYOUT_REPORT',
    'PAYOUT_SUMMARY_REPORT',
    'INVOICE',
    'CREDIT',
    'CREDIT_CARD_RECEIPT',
    'POSTADMANAGER_SOLUTION_OFFER',
    'POSTADMANAGER_DETAIL_OFFER',
    'POSTADMANAGER_TASKS_TIMETABLE',
    'POSTADMANAGER_INVOICE',
    'POSTADMANAGER_INVOICE_ACCOUNTING_LIST',
    'POSTADMANAGER_BRIEFING',
    'SELFBOOKING_ORDER',
    'SELFBOOKING_CAMPAIGN_RECEIPT',
    'SELFBOOKING_BALANCE_RECEIPT',
    'SELFBOOKING_INVOICE',
];
export const PdfRowEnumValues = [
    'ACCOUNT_DETAILS',
    'ACTOR',
    'ACTIVITY',
    'AD_TYPE_SIZES',
    'ADVERTISER',
    'ADDRESSED_MAILINGS',
    'AMOUNT_TOTAL',
    'EXISTING_CUSTOMERS_EXCLUDED',
    'AMOUNT_KUBA',
    'AMOUNT_AZ',
    'AMOUNT_DE',
    'AMOUNT_FR',
    'AMOUNT_IT',
    'SHIPPING_DETAILS',
    'NET_PRICE',
    'VAT_NUMBER',
    'AGENCY',
    'AGENCY_NET',
    'AMOUNT',
    'AMOUNT_OF_BROADCASTS',
    'BANK_ACCOUNT_NUMBER',
    'BIC_SWIFT',
    'BILLING_ADDRESS',
    'BILLING_PERIOD',
    'ISSUER_ADDRESS',
    'BK_AMOUNT',
    'BK_PERCENTAGE',
    'BLACK_AND_WHITE',
    'BROKER',
    'CAMPAIGN_DURATION',
    'CAMPAIGN_PLANING',
    'CANCELLATION',
    'CHANNEL',
    'CLICKS',
    'COLOR',
    'COMMENT',
    'CONSULTANT',
    'CONTACT',
    'COST_CARRIER',
    'CPM',
    'CREDIT',
    'CTR',
    'CUSTOMER_CONTACT',
    'CUSTOMER_NET',
    'CUSTOMER_NUMBER',
    'DATE',
    'DAY',
    'DELIVERY_RATE',
    'DEPOSIT_FOR',
    'DIGITAL',
    'DIGITAL_TOTAL',
    'DIGITAL_TOTAL_NET',
    'DISCOUNT_AMOUNT',
    'DISCOUNT_PERCENTAGE',
    'DISCOUNT_POSITIONS',
    'EARLY_PAYMENT_TERMS',
    'ADDITIONAL_TAX',
    'ECPM_NET3',
    'ELECTRONIC_BILL_IN',
    'EMAIL',
    'APPROVED_BY_USER_EMAIL',
    'END_DATE',
    'ENTER_INVOICE_NUMBER',
    'EXPECTED_CREATIVES',
    'FIXED_PRICE',
    'FORMAT_SIZE',
    'DOCUMENT_DATE',
    'GROSS',
    'GROSS2',
    'GROSS3',
    'HOUR',
    'IBAN',
    'IMPRESSIONS',
    'INFORMATION',
    'INTERNAL_NUMBER',
    'INVOICE',
    'INVOICE_AMOUNT',
    'INVOICE_DATE',
    'INVOICE_NUMBER',
    'INVOICE_THANKS',
    'PREVIOUS_INVOICE_ID',
    'INVOICE_DISCOUNT',
    'INVOICE_GROSS',
    'INVOICE_NET',
    'UNADDRESSED_POSITIONS',
    'IN_FAVOR_OF',
    'LIFE_TIME',
    'LIST_PRICE',
    'MARKETER',
    'MILESTONE',
    'MAX_CPM',
    'MEDIA',
    'MONTH',
    'NET',
    'NONE',
    'NUMBER',
    'OFFER',
    'ORDER',
    'ONLINE',
    'ONLINE_TOTAL',
    'ONLINE_POSITIONS',
    'PAYMENT_BY_CARD',
    'PAYOUT_COMMENT',
    'PAYOUT_NUMBER',
    'PLAYOUT',
    'PHASE',
    'PHONE',
    'POSITION',
    'POSITION_COMMENT',
    'POSITION_NAME',
    'POSITION_DATE',
    'POSTPROCESSING',
    'PREPARATION',
    'PRINT',
    'PRINT_MATERIAL_DEADLINE',
    'PRINT_TOTAL',
    'PRINT_TOTAL_NET',
    'PRODUCTION_SIZE',
    'PUBLICATION_DATE',
    'PUBLISHER_PAYOUT',
    'QR_IBAN',
    'QR_REFERENCE',
    'RADIO',
    'RADIO_TOTAL',
    'RADIO_TOTAL_NET',
    'RECEIPT',
    'REFERENCE_NUMBER',
    'RELEASE',
    'REPORT',
    'REVENUE',
    'RUNTIME',
    'SALES_CONTACT',
    'SPOT_LENGTH',
    'START_DATE',
    'SUBCONTRACTOR',
    'TOTAL',
    'MAILING_TOTAL',
    'ADDRESSED',
    'ADDRESSED_MAILING_TOTAL',
    'EMAIL_TOTAL',
    'SERVICE',
    'SERVICE_TOTAL',
    'REACH',
    'TOTAL_TABLE',
    'TOTAL_REACH',
    'TOTAL_NETTO',
    'TOTAL_GROSS',
    'UNADDRESSED',
    'UNADDRESSED_MAILINGS',
    'DIGITAL_POSITIONS',
    'SERVICE_POSITIONS',
    'KUREPO',
    'FRANKIERLIZENZ',
    'TOP_UP_RECEIPT',
    'TOTAL_GROSS_VAT',
    'TOTAL_INCL_VAT',
    'TOTAL_EXCL_VAT',
    'TOTAL_NET',
    'TOTAL_VAT',
    'TOTAL_NO_VAT',
    'DOMESTIC_COUNTRY_ADDITIONAL_INFO',
    'FOREIGN_COUNTRY_ADDITIONAL_INFO',
    'TV',
    'TV_TOTAL',
    'TV_TOTAL_NET',
    'TYPE',
    'UNIQUE_IDENTIFIER',
    'USE_INVOICE_DETAILS',
    'VAT',
    'VMK_AMOUNT',
    'VMK_PERCENTAGE',
    'WEEK',
    'YOUR_VAT',
    'DISTRIBUTION_DATE',
    'DELIVERY_DATE',
    'NUMBER_OF_SHIPMENTS_DE',
    'NUMBER_OF_SHIPMENTS_FR',
    'NUMBER_OF_SHIPMENTS_IT',
    'NUMBER_OF_SHIPMENTS',
    'RANGE',
    'PRICE',
    'LIFETIME',
    'QUANTITY',
    'TARGETING_BOTTOM_INFO',
    'AFFINITIES',
    'LANGUAGES',
    'TARGET_GROUP',
    'TARGETING_PAGE',
    'INCOMES',
    'GENDERS',
    'HOUSEHOLD_SIZES',
    'AGES',
    'ANALOG',
    'ANALOG_TOTAL',
    'NUMBER_OF_SELECTED_BRANCHES',
    'SURCHARGE_AMOUNT',
    'PRODUCTION',
    'FORMAT',
    'CATEGORY_MANAGER_DEADLINE',
    'LAYOUT_DELIVERY_DEADLINE',
    'ADVERTISEMENTS',
    'CONTACT_EMAIL',
    'CONTACT_PHONE',
    'CALENDAR_WEEK',
    'SHARE_OF_VOICE',
    'CREATIVE_DELIVERY_DEADLINE',
    'POINT_OF_SALE',
    'POINT_OF_SALE_TOTAL',
    'POINT_OF_SALE_TOTAL_NET',
    'CREATION_DEADLINE',
    'EXTERNAL_REFERENCE',
    'RAW_MATERIAL_DEADLINE',
    'POS_PRINT_MATERIAL_DEADLINE',
    'CROSSMEDIA',
    'CROSSMEDIA_TOTAL',
    'CROSSMEDIA_TOTAL_NET',
    'ACCOUNT_EXTERNAL_REFERENCE',
    'COWO_WEEK',
    'TARGETING_INVENTORY_FINDER_LINK',
    'INVOICE_CONTACT_NAME',
    'INVOICE_CONTACT_EMAIL',
    'DEADLINE_1',
    'DEADLINE_2',
    'DEADLINE_3',
    'TOTAL_IMPRESSIONS',
    'TOTAL_CLICKS',
    'POST_BRIEFING_TITLE',
    'PAM_NUMBER',
    'LINK_TO_CAMPAIGN',
    'GOAL',
    'CONTENT',
    'CONTENT_HINT',
    'TEXT_INPUT_PLACEHOLDER',
    'AREA',
    'TIMING',
    'CHANNELS',
    'ADDRESSED_CHANNELS',
    'ONLINE_CHANNELS',
    'DIGITAL_CHANNELS',
    'EMAIL_CHANNELS',
    'OTHER_CHANNELS',
    'BUDGET',
    'DISCOUNTS',
    'ADDRESSED_LETTERS_DISCOUNT',
    'DENY',
    'CONFIRM',
    'TEXT_PERCENTAGE',
    'PROMOPOST_DISCOUNT',
    'SPECIAL_DISCOUNT',
    'NOTES',
    'OFFER_UNTIL',
    'OFFER_UNTIL_COMMENT',
    'NOTE_LEADTIME',
    'WEEK_NUMBER',
    'NATIVE',
    'ADVISOR',
    'ADDRESS',
    'CREDIT_CARD_LAST_4',
    'PAYOUT_DATE_PREFIX',
    'WEBSITE_NAME',
    'COST_UNIT',
];
export const LanguageCodeEnumValues = ['DE', 'EN', 'FR', 'IT'];
export const OidcIssuerNameEnumValues = ['SWISS_POST', 'COOP'];
export const PrintOperationExportTypeEnumValues = ['ADFLOW', 'TOPAS', 'CICLON', 'COOP', 'NONE'];
export const PrintCreativeExportTypeEnumValues = ['ONEVISION'];
export const ExternalReferenceTypeEnumValues = ['STRING', 'NUMERIC'];
export const PdfMediaTypeEnumValues = [
    'DIGITAL',
    'PRINT',
    'RADIO',
    'TV',
    'POS',
    'ANALOG',
    'CROSSMEDIA',
    'UNADDRESSED_MAILINGS',
    'DIGITAL_POSITIONS',
    'ADDRESSED_MAILINGS',
    'EMAILS',
    'ONLINE_POSITIONS',
    'SERVICE_POSITIONS',
    'DISCOUNT_POSITIONS',
];
export const UiThemeEnumValues = ['DARK', 'LIGHT', 'SYSTEM'];
export {};
